<div 
    class="item-box" 
    [attr.data-testid]="'menu-item-' + item.id"
    [class.grid-view]="isGridView || isHighlighted" 
    [class.highlight]="isHighlighted" 
    [class.unavailable]="isUnavailable" 
    [class.no-image]="isImageHideable"
    [class.compact]="compact"
    (click)="openModifierSheet()">
    <div class="img-box img-shimmer">
        <img [lazyLoad]="item.image_url" [defaultImage]="placeholderImage()" [errorImage]="placeholderImage()" (onStateChange)="onImageStateChange($event)" />
        @if (isCombo && isHighlighted) {
            <span class="combo-badge">{{ 'COMMON.COMBO' | translate }}</span>
        }
        @if (sectionBadge) {
            <span class="section-badge">{{ sectionBadge }}</span>
        }
    </div>
    <div class="content-wrap">
        @if (isCombo && !isHighlighted) {
            <span class="combo-badge">{{ 'COMMON.COMBO' | translate }}</span>
        }
        <div class="content-box">
            <h5>{{ item.name }}</h5>
            @if (!compact) {
                <p [class.mb]="(isGridView && !item.calories) || isHighlighted">{{ item.description }}</p>
            }
            <div class="price-calories">
                @if (item.price !== 0) {
                <span class="price">{{ item.price | currencySpace }}</span>
                }
                @if (item.calories) {
                <span translate [translateParams]="{ calories: item.calories }">COMMON.CALORIES</span>
                }
            </div>
        </div>

        @if (!isReadOnly) {
        <div class="stepper-box" [class.bottom]="item.calories" (click)="$event.stopPropagation()">
            <div class="stepper" [class.vertical]="!isGridView || isHighlighted">
                @if (quantity() === 0 || compact) {
                <button data-testid="menu-item-increase" [disabled]="isUnavailable" type="button" (click)="increase()">
                    <mat-icon>add</mat-icon>
                </button>
                } @else {
                <button data-testid="menu-item-increase" [disabled]="isUnavailable" type="button" (click)="increase()">
                    <mat-icon>add</mat-icon>
                </button>
                <span data-testid="menu-item-quantity">{{ quantity() }}</span>
                <button data-testid="menu-item-decrease" [disabled]="isUnavailable" type="button" (click)="decrease()">
                    <mat-icon>remove</mat-icon>
                </button>
                }
            </div>
        </div>
        }
    </div>
</div>